import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListSubmittedMetricsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'MetricSelector',
  props: {
    title: {
      default: ''
    },
    subtitle: {
      default: ''
    },
    tooltip: {
      default: ''
    },
    value: {
      default: function _default() {
        return [];
      }
    },
    query: {
      default: function _default() {
        return {};
      }
    },
    allowCustom: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fundId: {
      default: null
    }
  },
  emits: ["input"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var showSearchDialog = ref(false);
    var normalizedMetrics = computed(function () {
      return (props.value || []).map(function (item) {
        if (typeof item === 'number') {
          return {
            id: item,
            name: "#".concat(item)
          };
        }
        return item;
      }).filter(function (metric) {
        return !!(metric !== null && metric !== void 0 && metric.id);
      });
    });
    var selectedMetricIds = computed(function () {
      return normalizedMetrics.value.map(function (metric) {
        return Number(metric.id);
      }).filter(function (id) {
        return !Number.isNaN(id);
      });
    });
    var tableHeight = computed(function () {
      // Approx: header + row-height * rows + small buffer, clamped to keep UX stable.
      var rows = selectedMetricIds.value.length;
      var base = 100;
      var rowHeight = 100;
      var buffer = 16;
      var minHeight = 300;
      var maxHeight = 800;
      return "".concat(Math.min(maxHeight, Math.max(minHeight, base + rows * rowHeight + buffer)), "px");
    });
    var submittedMetricsVariables = computed(function () {
      var _props$fundId;
      return {
        fundId: (_props$fundId = props.fundId) !== null && _props$fundId !== void 0 ? _props$fundId : undefined,
        metricIds: selectedMetricIds.value,
        limit: selectedMetricIds.value.length,
        offset: 0
      };
    });
    var _useListSubmittedMetr = useListSubmittedMetricsQuery(submittedMetricsVariables, function () {
        return {
          enabled: !!props.fundId && selectedMetricIds.value.length > 0,
          fetchPolicy: 'cache-first'
        };
      }),
      metricAggregationsResult = _useListSubmittedMetr.result,
      loading = _useListSubmittedMetr.loading;
    var submittedMetricIds = computed(function () {
      var _metricAggregationsRe;
      var rows = ((_metricAggregationsRe = metricAggregationsResult.value) === null || _metricAggregationsRe === void 0 ? void 0 : _metricAggregationsRe.listMetricAggregations) || [];
      return new Set(rows.map(function (row) {
        var _row$metric;
        return Number((_row$metric = row.metric) === null || _row$metric === void 0 ? void 0 : _row$metric.id);
      }).filter(function (id) {
        return !Number.isNaN(id);
      }));
    });
    var unsubmittedMetrics = computed(function () {
      return normalizedMetrics.value.filter(function (metric) {
        return !submittedMetricIds.value.has(Number(metric.id));
      }).map(function (metric) {
        return {
          id: Number(metric.id),
          name: metric.name || "#".concat(metric.id)
        };
      });
    });
    var withCoupledMetrics = function withCoupledMetrics(metricIds) {
      var prevMetricIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var ids = _toConsumableArray(metricIds);
      if (ids.includes(292) && !ids.includes(367) && !prevMetricIds.includes(367)) {
        ids.push(367);
      }
      if (ids.includes(367) && !ids.includes(292) && !prevMetricIds.includes(292)) {
        ids.push(292);
      }
      return Array.from(new Set(ids));
    };
    var emitMetricIds = function emitMetricIds(ids) {
      emit('input', Array.from(new Set(ids)));
    };
    var linkMetricsFromDatabase = function linkMetricsFromDatabase(items) {
      var oldMetricIds = selectedMetricIds.value;
      var metricIds = items.map(function (metric) {
        return Number(metric.id);
      });
      var updatedMetricIds = withCoupledMetrics(metricIds, oldMetricIds.concat(metricIds));
      emitMetricIds(oldMetricIds.concat(updatedMetricIds));
    };
    var unlinkMetricById = function unlinkMetricById(id) {
      if (props.disabled) {
        return;
      }
      var metricId = Number(id);
      var nextIds = selectedMetricIds.value.filter(function (itemId) {
        return itemId !== metricId;
      });
      emitMetricIds(nextIds);
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      showSearchDialog: showSearchDialog,
      normalizedMetrics: normalizedMetrics,
      selectedMetricIds: selectedMetricIds,
      tableHeight: tableHeight,
      submittedMetricsVariables: submittedMetricsVariables,
      metricAggregationsResult: metricAggregationsResult,
      loading: loading,
      submittedMetricIds: submittedMetricIds,
      unsubmittedMetrics: unsubmittedMetrics,
      withCoupledMetrics: withCoupledMetrics,
      emitMetricIds: emitMetricIds,
      linkMetricsFromDatabase: linkMetricsFromDatabase,
      unlinkMetricById: unlinkMetricById
    };
  }
});